import { apiSlice } from "../api/apiSlice";

export const teamsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeams: builder.query({
      query: (email) =>
        `/teams?teamMember=${email}&_sort=timestamp&_order=desc`,
    }),
    getTeam: builder.query({
      query: (id) => `/teams?id=${id}&_sort=timestamp&_order=desc`,
    }),
    addTeams: builder.mutation({
      query: ({ data }) => ({
        url: "/teams",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        let email = arg.data.teamMember;
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getTeams", email, (draft) => {
            draft.unshift({
              ...arg.data,
              id: draft.length + 1,
            });
          })
        );
        // optimistic cache update end
        try {
        } catch (error) {
          pathResult.undo();
        }
      },
    }),
    teamAssigne: builder.mutation({
      query: ({ id, data, sender }) => ({
        url: `/teams/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getTeams", arg.id, (draft) => {
            const draftTeams = draft.find((c) => c.id == arg.id);
            draftTeams.teamUsers = arg.data.teamMemberList;
            draftTeams.teamMember = arg.data.teamMember;
          })
        );
        // optimistic cache update end

        try {
        } catch (error) {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const {
  useAddTeamsMutation,
  useGetTeamsQuery,
  useTeamAssigneMutation,
  useGetTeamQuery,
} = teamsApi;
